const actionTypes = {
    AUTHORIZE: 'AUTHORIZE',
    DEAUTHORIZE: 'DEAUTHORIZE',
}

Object.freeze(actionTypes)

export { actionTypes }